//Dashboard Screen NextUI
import { Grid, Spacer, Switch } from '@nextui-org/react'
import React from 'react'
import ContactBook from '../Components/ContactBook'
import HistoricBlock from '../Components/HistoricBlock'
import NavBar from '../Components/NavBar'
import SmsBlock from '../Components/SmsBlock'
import { toast } from 'react-toastify'
import { BsFillMoonStarsFill, BsFillSunFill } from "react-icons/bs";
import { useThemes } from '../Hooks/useThemes'

const Dashboard = () => {
    const [phoneSelected, setPhoneSelected] = React.useState("");
    const [theme, toggleTheme] = useThemes();
    
    const handlePhoneSelected = (phone) => {
        setPhoneSelected(phone);
        toast.info("Vous avez sélectionné le numéro: " + phone, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            theme: "colored",
        })
    }

/*     //Liste des numéros de téléphone sélectionnés et ajouter des points virgules entre chaque numéro
    const [listPhoneSelected, setListPhoneSelected] = React.useState([]);
    const handleListPhoneSelected = (phone) => {
        if (listPhoneSelected.length > 0) {
            setPhoneSelected(listPhoneSelected + ";" + phone);
        } else {
            setPhoneSelected(phone);
        }
        setListPhoneSelected([...listPhoneSelected, phone]);
        toast.info("Vous avez sélectionné le numéro: " + phone, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            theme: "colored",
        })
    }
 */
    return (
        <div>
            <Grid.Container justify='center'>
                <Grid>
                    <Spacer y={0.5} />    
                     <NavBar />
{/*                      <Switch
                        checked={true}
                        size="xl"
                        onChange={toggleTheme}
                        iconOn={<BsFillSunFill filled />}
                        iconOff={<BsFillMoonStarsFill filled />}
                    /> */}
                </Grid>
            </Grid.Container>
            <Grid.Container gap={2} justify="center">
                <Grid xs={12} md={4}>
                    <SmsBlock 
                        number={phoneSelected}
                    />
                </Grid>
                <Grid xs={12} md={4}>
                    <ContactBook
                        phoneNumber={handlePhoneSelected}
                    />  
                </Grid>
                <Grid xs={12} md={4}>
                    <HistoricBlock/>
                </Grid>
            </Grid.Container>
        </div>
    )
}

export default Dashboard
    